import React from 'react'
import { AiFillWindows } from 'react-icons/ai'
import { FiArrowDown, FiExternalLink, FiPackage, FiShield, FiZap } from 'react-icons/fi'
import { ZIP_FILE, INSTALLER_FILE } from '../../../const/endpoints.ts'
import DownloadTable from './DownloadTable.jsx'

export default function Download() {
  return (
    <div className="page download-page">
      <header className="download-hero">
        <div className="eyebrow"><FiArrowDown aria-hidden="true" /> Latest release</div>
        <h1>Neurorule for <span>Windows.</span></h1>
        <p>Bring explainable data analysis to your desktop. Download the installer and start turning complex datasets into human-readable insight.</p>
      </header>

      <section className="release-card" aria-labelledby="windows-release-title">
        <div className="release-visual" aria-hidden="true">
          <div className="windows-mark"><AiFillWindows /></div>
          <div className="release-orb" />
        </div>
        <div className="release-content">
          <div className="release-meta"><span className="release-badge">Latest</span><span>Version 1.0.0</span></div>
          <h2 id="windows-release-title">Windows release</h2>
          <p>Use the guided installer for the simplest setup, or download the ZIP archive if you prefer a portable package.</p>
          <div className="release-actions">
            <a className="button button-primary release-button" href={INSTALLER_FILE} target="_blank" rel="noopener noreferrer">
              <FiArrowDown /> Download installer <FiExternalLink className="button-external" />
            </a>
            <a className="button button-secondary release-button" href={ZIP_FILE} target="_blank" rel="noopener noreferrer">
              <FiPackage /> Download ZIP <FiExternalLink className="button-external" />
            </a>
          </div>
          <p className="download-host-note">Downloads open securely in Google Drive.</p>
        </div>
      </section>

      <section className="download-benefits" aria-label="Release information">
        <article><span><FiZap /></span><div><h3>Ready to explore</h3><p>Move from importing data to analysis and model training in one visual workspace.</p></div></article>
        <article><span><FiShield /></span><div><h3>Transparent by design</h3><p>Generate explainable neuro-fuzzy rules and review model metrics before acting.</p></div></article>
        <article><span><FiPackage /></span><div><h3>Two package options</h3><p>Choose the Windows installer or the downloadable ZIP archive.</p></div></article>
      </section>

      <section className="release-history">
        <div><span className="section-label">Release history</span><h2>Available versions</h2></div>
        <DownloadTable />
      </section>
    </div>
  )
}
